export { default } from './footer-csr-menu';
